import {
  FAIL_FETCH_PLAYER_POOL,
  REQUEST_FETCH_PLAYER_POOL,
  SUCCESS_FETCH_PLAYER_POOL,
} from '../../../actions/app/playerPool';
import {createReducer} from '../../utilities';

const initialPlayerPoolState = {
  data: null,
  info: {
    isFetching: false,
    lastAction: null,
    needRefresh: true,
    updatedAt: null,
    success: false,
    error: false,
  },
};

function request(state, action) {
  return {
    ...state,
    info: {
      isFetching: true,
      lastAction: action.type,
      needRefresh: false,
      updatedAt: null,
      success: false,
      error: false,
    },
  };
}

function success(state, action) {
  const {data, receivedAt, success} = action;
  return {
    ...state,
    data,
    info: {
      ...state.info,
      isFetching: false,
      needRefresh: false,
      updatedAt: receivedAt,
      success,
      error: false,
    },
  };
}

function fail(state, action) {
  const {error} = action;
  return {
    ...state,
    error,
  };
}

export default createReducer(initialPlayerPoolState, {
  [REQUEST_FETCH_PLAYER_POOL]: request,
  [SUCCESS_FETCH_PLAYER_POOL]: success,
  [FAIL_FETCH_PLAYER_POOL]: fail,
});



// WEBPACK FOOTER //
// ./src/reducers/app/playerPool/index.js